/** @format */

import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import {
  HmfButtonComponent,
  HmfPriceComponent,
  HmfProductImageComponent,
  HmfStarRatingsComponent,
  type HmfProductData,
} from '@dsg-tech/homefield-angular';

@Component({
  selector: 'shared-components-criteo-video-product-card',
  imports: [
    HmfButtonComponent,
    HmfPriceComponent,
    HmfProductImageComponent,
    HmfStarRatingsComponent,
  ],
  templateUrl: './criteo-video-product-card.component.html',
  styleUrl: './criteo-video-product-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CriteoVideoProductCardComponent {
  readonly product = input.required<HmfProductData>();
  readonly addToCartClicked = output<void>();

  readonly truncatedRatingValue = computed(() =>
    this.truncateRatingValue(this.product().starRatings?.ratingValue),
  );

  onAddToCartClick(event: Event) {
    event.stopPropagation();
    this.addToCartClicked.emit();
  }

  private truncateRatingValue(ratingValue: number | undefined | null): number {
    return Math.trunc((ratingValue ?? 0) * 10) / 10;
  }
}
